import React from "react";

/**
 * Plain single-select radio group, decoupled from react-reactive-form and
 * the CSR `wizardForm`/`useQuestions()` context - `QuestionItem`'s radio
 * rendering is irreducibly tied to that machinery, so it isn't reusable for
 * a product that intentionally doesn't adopt it. `value` may be `null` to
 * render with nothing selected (used for questions with no default, e.g.
 * Patient Narrative's blinding status).
 */
const RadioGroup = ({
  name,
  value = null,
  onChange,
  options,
  disabled = false,
}) => (
  <div className="questions-content__input">
    {options.map(choice => (
      <React.Fragment key={choice.value}>
        <input
          className="btn-check"
          type="radio"
          id={`${name}-${choice.value}`}
          name={name}
          checked={value === choice.value}
          disabled={disabled}
          onChange={() => onChange(choice.value)}
        />
        <label className="btn btn-light" htmlFor={`${name}-${choice.value}`}>
          {choice.title}
          {choice.recommended ? " (Recommended)" : ""}
        </label>
      </React.Fragment>
    ))}
  </div>
);

export default RadioGroup;
